import { render, staticRenderFns } from "./PageSectionsTypesList.vue?vue&type=template&id=011289e4&scoped=true"
import script from "./PageSectionsTypesList.vue?vue&type=script&lang=js"
export * from "./PageSectionsTypesList.vue?vue&type=script&lang=js"
import style0 from "./PageSectionsTypesList.vue?vue&type=style&index=0&id=011289e4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011289e4",
  null
  
)

export default component.exports